import Button from '@material-ui/core/Button';
import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  DeglawyTrophy, IDeglawyTrophyStore,
} from '../../mobx-store/storeInterfaces/delawyTrophyInterface';

interface IProps extends WithSnackbarProps {
  deglawyTrophyStore: IDeglawyTrophyStore;
  history: any;
}

@inject('deglawyTrophyStore')
@observer
class DeglawyTrophyScreen extends Component<IProps> {
  title: string = translate('deglawyTrophiesListPageTitle', {
  });

  addButton: any;

  tableHeader: any = [];

  tableCellTypes: TableCellTypes[] = [];

  tableData: any[] = [];

  constructor(props: IProps) {
    super(props);
    this.addButton = this.getAddDeglawyTrophyButton();
    this.tableHeader = this.getDeglawyTrophyTableHeader();
    this.tableCellTypes = this.getArticleTableCellTypes();
  }

  handleTableButtonCellClicked = (index: number, key: string) => {
    this.props.history.push(
      `/deglawy/trophies/${this.props.deglawyTrophyStore.delawyTrophiesList[index].getId()}/edit`,
    );
  };

  handleTableToggleCellChange = (index: number, key: string, value: boolean) => {
    this.props.deglawyTrophyStore.updateDeglawyTrophyStatus(value, index)
      .then(() => {
        SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
        }), 6000, 'success');
      })
      .catch((error: any) => {
        SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
        }), 10000, 'error');
      });
  };

  openSnackbar = (message: string, duration: number, status: 'success'|'warning'|'error'|'info') => {
    this.props.enqueueSnackbar(message, {
      autoHideDuration: duration,
      variant: status,
      action: (
        <Button color="default">Dismiss</Button>
      ),
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
      },
    });
  };

  handelAdd = (): void => {
    this.props.history.push('/deglawy/trophies/new');
  };

  getAddDeglawyTrophyButton = () => ({
    title: translate('deglawyTrophyListAddButton', {
    }),
    onAdd: this.handelAdd,
  });

  getDeglawyTrophyTableHeader = () => [
    {
      title: translate('deglawyTrophyListTitleColumnTitle', {
      }),
    },
    {
      title: translate('deglawyTrophyListPointsColumnTitle', {
      }),
    },
    {
      title: translate('deglawyTrophyListStatusColumnTitle', {
      }),
    },
    {
      title: translate('deglawyTrophyListEditColumnTitle', {
      }),
    },
  ];

  getDeglawyTrophyTableData = () => this.props.deglawyTrophyStore.delawyTrophiesList
    .map((deglawyTrophy: DeglawyTrophy) => ({
      ...deglawyTrophy.getTrophy(), edit: 'Edit',
    }));

  getArticleTableCellTypes = (): TableCellTypes[] => [
    {
      cellType: 'Text',
      key: 'title',
    },
    {
      cellType: 'Text',
      key: 'points',
    },
    {
      cellType: 'ToggleButton',
      key: 'isActive',
      activeLabel: 'Active',
      inactiveLabel: 'Not active',
      onChange: this.handleTableToggleCellChange,
    },
    {
      cellType: 'Button',
      key: 'edit',
      onClick: this.handleTableButtonCellClicked,
    },
  ];

  render() {
    this.tableData = this.getDeglawyTrophyTableData();
    return (
      <div>
        <GeneralTableComponent
          emptyMessage={translate('deglawyTrophyListNoImageMessage', {
          })}
          title={this.title}
          tableHeader={this.tableHeader}
          tableData={this.tableData}
          tableCellTypes={this.tableCellTypes}
          addButton={this.addButton}
          loading={this.props.deglawyTrophyStore.loading}
        />
      </div>
    );
  }

  componentDidMount() {
    this.props.deglawyTrophyStore.getDelawyTrophies();
  }
}

export default DeglawyTrophyScreen;
